export const logicaTomarTurno = (
  turnosDisponibles,
  ordenDigitalState,
  turno,
  selectDropDown,
  pacienteAuth,
  configState,
  type,
  dtoNuevaBusqueda,
  idProtocolo,
  osAlternativa,
) => {
  const esParticular = turnosDisponibles.turnosDisponibles.turnosData
    .dtoBusqueda.flgEspecialidadPart
    ? turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
        .flgEspecialidadPart
    : turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda.particular
      ? turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda.particular
      : false;
  const esPorVideollamada =
    turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda.videoConsulta;
  const idTurno = turno.idTurno;
  const idTurnoCombinado = turno.idTurnoCombinadoturno || 0;
  const familiar = selectDropDown.selectDropDown.selectGlobal.pacienteElegido;
  const ordenDigital = ordenDigitalState.ordenDigital.altaTurno;
  const ordenDigitalMedico = ordenDigitalState.ordenDigital.idMedSolicitante;
  const versionFront = configState.config?.data?.version;
  const idFront = configState.config?.data?.sectorVersion;
  let accion = sessionStorage.getItem("accionHash");
  // const familiarConsultaMedica = selectDropDown.selectDropDown.consulMedica.pacienteElegido;
  // const familiarEstudios = selectDropDown.selectDropDown.estudios.pacienteElegido;
  // const familiarLaboratorio = selectDropDown.selectDropDown.laboratorio.pacienteElegido;
  if (type === "CONSULTA_MEDICA" && familiar) {
    let dtoTomarTurno = {
      idTurno: idTurno,
      idGrupoMedico: 0,
      // Si el paciente aceptó tomar como particular tras un código 9 del
      // verificaOs (OS dada de baja o no cubre), pisamos la OS por "PART"
      // para que el back no rechace por validaciones de obra social.
      idObraSocial: esParticular ? "PART" : familiar.paciente.obraSocial,
      idPaciente: familiar.paciente.codigo,
      idPlan: familiar.paciente.idPlan,
      operador: accion ? "BOT" : "",
      tipoiva: familiar.paciente.tipoIva,
      particular: esParticular,
      videoConsulta: esPorVideollamada,
      sectorTurno: process.env.SECTOR_TURNO,
      descripcion: turno.medico,
      idFront: idFront,
      versionFront: versionFront,
    };
    return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.codigo };
  } else if (type === "CONSULTA_MEDICA") {
    let dtoTomarTurno = {
      idTurno: idTurno,
      idGrupoMedico: 0,
      idObraSocial: esParticular
        ? "PART"
        : pacienteAuth.auth?.data?.paciente?.obraSocial,
      idPaciente: pacienteAuth.auth?.data?.paciente?.codigo,
      idPlan: pacienteAuth.auth?.data?.paciente?.idPlan,
      operador: accion ? "BOT" : "",
      sectorTurno: process.env.SECTOR_TURNO,
      tipoiva: pacienteAuth.auth?.data?.paciente?.tipoIva,
      particular: esParticular,
      videoConsulta: esPorVideollamada,
      descripcion: turno.medico,
      idFront: idFront,
      versionFront: versionFront,
    };

    return { dto: dtoTomarTurno, idFamiliar: false };
  }
  if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen !==
      "CONSULTA_MEDICA" &&
    familiar
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: familiar.paciente.idPlan,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: familiar.paciente.tipoiva,
      idOrdenDigital: ordenDigital ? ordenDigital : -1,
      idMedSolicitante: ordenDigitalMedico !== null ? ordenDigitalMedico : "",
      idTurnoCombinado: idTurnoCombinado,
      idFront: idFront,
      versionFront: versionFront,
    };
    return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.codigo };
  } else if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen !==
      "CONSULTA_MEDICA"
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: pacienteAuth.auth?.data?.paciente?.idPlan,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: pacienteAuth.auth?.data?.paciente?.tipoiva,
      idOrdenDigital: ordenDigital ? ordenDigital : -1,
      idMedSolicitante: ordenDigitalMedico !== null ? ordenDigitalMedico : "",
      idTurnoCombinado: idTurnoCombinado,
      idFront: idFront,
      versionFront: versionFront,
    };

    return { dto: dtoTomarTurno, idFamiliar: false };
  } else if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen ===
      "CONSULTA_MEDICA" &&
    !familiar
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: pacienteAuth.auth?.data?.paciente?.idPlan,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: pacienteAuth.auth.data.paciente.tipoiva,
      idTurnoCombinado: idTurnoCombinado,
      tipoiva: pacienteAuth.auth?.data?.paciente?.tipoiva,
      idFront: idFront,
      versionFront: versionFront,
    };
    return { dto: dtoTomarTurno, idFamiliar: false };
  } else if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen ===
      "CONSULTA_MEDICA" &&
    familiar
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: familiar.paciente.idPlan,
      idObraSocial: familiar.paciente.obraSocial,
      idPaciente: familiar.paciente.codigo,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: familiar.paciente.tipoiva,
      idTurnoCombinado: idTurnoCombinado,
      idFront: idFront,
      versionFront: versionFront,
    };
    return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.codigo };
  }
  if (
    idProtocolo !== null &&
    idProtocolo !== undefined &&
    idProtocolo !== "-1" &&
    !familiar
  ) {
    let dtoTomarTurno = {
      id: idTurno,
      IdGrupoEstAlta: dtoNuevaBusqueda.idGrupo,
      IdGrupoEstudio: dtoNuevaBusqueda.idGrupo,
      esParticular: turnosDisponibles.turnosDisponibles.turnosData.particular,
      IdProtocoloAlta: idProtocolo,
      OsAlternativa: osAlternativa,
      idFront: idFront,
      versionFront: versionFront,
    };
    return { dto: dtoTomarTurno, idFamiliar: false };
  } else {
    if (type === "LABORATORIO" && familiar) {
      let dtoTomarTurno = {
        id: idTurno,
        IdGrupoEstAlta: dtoNuevaBusqueda.idGrupo,
        IdGrupoEstudio: dtoNuevaBusqueda.idGrupo,
        sectorTurno: process.env.SECTOR_TURNO,
        esParticular: turnosDisponibles.turnosDisponibles.turnosData.particular,
        tipoiva: familiar.paciente.tipoiva,
        IdProtocoloAlta: idProtocolo,
        OsAlternativa: osAlternativa,
        idFront: idFront,
        versionFront: versionFront,
      };
      return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.codigo };
    } else if (type === "LABORATORIO") {
      let dtoTomarTurno = {
        id: idTurno,
        IdGrupoEstAlta: dtoNuevaBusqueda.idGrupo,
        IdGrupoEstudio: dtoNuevaBusqueda.idGrupo,
        sectorTurno: process.env.SECTOR_TURNO,
        esParticular: turnosDisponibles.turnosDisponibles.turnosData.particular,
        tipoiva: pacienteAuth.auth?.data?.paciente?.tipoiva,
        OsAlternativa: osAlternativa,
        idFront: idFront,
        versionFront: versionFront,
      };
      return { dto: dtoTomarTurno, idFamiliar: false };
    }
  }
};
